import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import Download from '@mui/icons-material/Download'
import Print from '@mui/icons-material/Print'
import PrintOutlined from '@mui/icons-material/PrintOutlined'
import Save from '@mui/icons-material/Save'
import Settings from '@mui/icons-material/Settings'
import { Spinner } from 'react-bootstrap'
import { PRESCRIPTION_BUILDER_VIEW_TYPES } from 'src/consumer/constants'
import { PMPButtonForConsultation, PMPButtonsContainer } from '../PrescriptionMakingPageStyles'
import Tooltip from '@mui/material/Tooltip'
import ExportTypeSelector from 'src/clinic/views/clinicBrandPayoutReports/components/ExportTypeSelector'
import { EXPORT_TYPES } from 'src/clinic/views/clinicBrandPayoutReports/util'

export default function TopPatientDetailsHeading({
  saveAndPrint,
  prescriptionSaveLoading,
  savePrescriptionData,
  prescriptionViewSettings,
  currentPage,
  emrSectionsToShowInOrder,
  showPatientDetails,
  nextSection,
  previousSection,
  currentPageHistory,
  inChamber = false,
  saveAndDownloadPDF,
  onRxPrint, // Callback to open Rx drawer and trigger PRINT ALL
  onQuickPrint, // Callback to trigger Quick Print
  onEditSections, // Callback to open EMR sections editor dialog
}) {
  function renderRightHandSideButtonsForTabletView() {
    if (currentPage < emrSectionsToShowInOrder.length - 2) {
      return (
        <PMPButtonForConsultation sx={{ pointerEvents: 'all' }} onClick={nextSection}>
          <span>{emrSectionsToShowInOrder?.[currentPage + 2]?.title}</span>{' '}
          <ArrowForward sx={{ fontSize: '1.1rem' }} />
        </PMPButtonForConsultation>
      )
    }
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '8px',
          background: 'white',
          justifyContent: 'right',
        }}
      >
        <PMPButtonForConsultation
          style={{ pointerEvents: 'all', width: 'min-content' }}
          whitebg
          onClick={saveAndPrint}
        >
          <Tooltip title="Save and Print" placement="left">
            <PrintOutlined />
          </Tooltip>
        </PMPButtonForConsultation>
        {onQuickPrint && (
          <PMPButtonForConsultation
            style={{ pointerEvents: 'all', width: 'min-content' }}
            whitebg
            onClick={onQuickPrint}
          >
            <Tooltip title="Quick Print" placement="left">
              <Print />
            </Tooltip>
          </PMPButtonForConsultation>
        )}
        <PMPButtonForConsultation
          style={{ pointerEvents: 'all', width: 'min-content' }}
          disabled={prescriptionSaveLoading}
          onClick={savePrescriptionData}
        >
          <Tooltip title="Save Only" placement="left">
            <Save />
          </Tooltip>
          {prescriptionSaveLoading && <Spinner animation="border" variant="light" size="sm" />}
        </PMPButtonForConsultation>
        {onEditSections && (
          <PMPButtonForConsultation
            style={{ pointerEvents: 'all', width: 'min-content' }}
            whitebg
            onClick={onEditSections}
          >
            <Tooltip title="Edit Sections" placement="left">
              <Settings />
            </Tooltip>
          </PMPButtonForConsultation>
        )}
      </div>
    )
  }

  function handleDownloadPDF(exportType) {
    switch (exportType) {
      case EXPORT_TYPES.pdf.id:
        saveAndDownloadPDF({ sendImmediately: false })
        break
      case EXPORT_TYPES.email_pdf.id:
        saveAndDownloadPDF({ sendImmediately: true })
        break
      default:
        break
    }
  }

  return (
    <>
      <PMPButtonsContainer
        className="px-4"
        alwaysInRow
        style={{
          width: 'auto',
          position: 'fixed',
          top: '125px',
          right: '15px', // Moved left to avoid overlapping scrollbar (was -20px)
          zIndex: 1001, // Higher than view toggle (1000) to appear on top
          boxShadow: showPatientDetails
            ? 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px'
            : 'unset',
          pointerEvents: !showPatientDetails ? 'none' : 'unset',
          background: showPatientDetails ? 'white' : 'unset',
          justifyContent: showPatientDetails
            ? 'space-between'
            : prescriptionViewSettings?.prescriptionBuilderViewType ===
              PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView
            ? 'space-between'
            : 'flex-end',
          padding: '8px',
        }}
      >
        {prescriptionViewSettings?.prescriptionBuilderViewType ===
          PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView && (
          <>
            {currentPage > 0 ? (
              <div>
                <PMPButtonForConsultation
                  onClick={previousSection}
                  style={{ pointerEvents: 'all' }}
                >
                  <ArrowBack sx={{ fontSize: '1.1rem' }} />{' '}
                  {
                    emrSectionsToShowInOrder?.[
                      (currentPageHistory?.[currentPageHistory?.length - 2] || 0) + 1
                    ]?.title
                  }
                </PMPButtonForConsultation>
              </div>
            ) : (
              <div>
                <PMPButtonForConsultation
                  disableRipple
                  style={{ opacity: 0, pointerEvents: 'all' }}
                >
                  <ArrowBack sx={{ fontSize: '1.1rem' }} />
                </PMPButtonForConsultation>
              </div>
            )}
          </>
        )}
        {prescriptionViewSettings?.prescriptionBuilderViewType ===
        PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView ? (
          <>{renderRightHandSideButtonsForTabletView()}</>
        ) : (
          <div
            style={{
              background: 'white',
              padding: '8px',
              borderRadius: '8px',
              boxShadow: 'rgb(0, 0, 0) 0px 0px 6px -2px',
              pointerEvents: 'all',
              justifyContent: 'right',
              gap: '8px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {onQuickPrint && (
              <PMPButtonForConsultation
                whitebg
                onClick={onQuickPrint}
                style={{ pointerEvents: 'all', width: 'min-content' }}
              >
                <Tooltip title="Quick Print" placement="left">
                  <Print />
                </Tooltip>
              </PMPButtonForConsultation>
            )}
            <PMPButtonForConsultation
              disabled={prescriptionSaveLoading}
              onClick={savePrescriptionData}
              style={{ pointerEvents: 'all', width: 'min-content' }}
            >
              <Tooltip title="Save Only" placement="left">
                <Save />
              </Tooltip>
              {prescriptionSaveLoading && <Spinner animation="border" variant="light" size="sm" />}
            </PMPButtonForConsultation>
            <ExportTypeSelector
            emailLabel="Send PDF to patient"
              mainButton={({ handleClick, isOpen }) => {
                return (
                  <PMPButtonForConsultation
                    disabled={prescriptionSaveLoading}
                    onClick={handleClick}
                    style={{ pointerEvents: 'all', width: 'min-content' }}
                  >
                    <Tooltip title="Download PDF" placement="left">
                      <Download />
                    </Tooltip>
                    {prescriptionSaveLoading && (
                      <Spinner animation="border" variant="light" size="sm" />
                    )}
                  </PMPButtonForConsultation>
                )
              }}
              handleSelectExportType={handleDownloadPDF}
              hideOptionsId={[EXPORT_TYPES.excel.id]}
            />
            <PMPButtonForConsultation
              whitebg
              onClick={saveAndPrint}
              style={{ pointerEvents: 'all', width: 'min-content' }}
            >
              <Tooltip title="Save and Print" placement="left">
                <PrintOutlined />
              </Tooltip>
            </PMPButtonForConsultation>
            {onEditSections && (
              <PMPButtonForConsultation
                whitebg
                onClick={onEditSections}
                style={{ pointerEvents: 'all', width: 'min-content' }}
              >
                <Tooltip title="Edit Sections" placement="left">
                  <Settings />
                </Tooltip>
              </PMPButtonForConsultation>
            )}
          </div>
        )}
      </PMPButtonsContainer>
    </>
  )
}
